import axios from "axios";

const API = axios.create({
    baseURL: 'https://api.mobistorm.in',
    //baseURL: 'https://api.beta.mobistorm.in',
});

export default API;